export const MEDIA_FILE_EXTENSIONS = [
  "mp3",
  "mp4",
  "wav",
  "aac",
  "flac",
  "mov",
  "ogg",
  "webm",
  "m4a",
  "m4v",
  "mpg",
  "mp2",
  "oga",
  "aiff",
  "aif",
  "amr",
  "mpga",
  "au",
  "ogm",
  "avi", // Added for synchronization with backend
  "mkv",
  "mpeg",
  "wmv",
  "flv",
  "ac3",
  "wma",
];

export const VIDEO_EXTENSIONS = [
  "mp4",
  "mov",
  "m4v",
  "mpg",
  "webm",
  "avi",
  "mkv",
  "mpeg",
  "wmv",
  "flv",
  "ogm",
];

export const TEXT_FILE_EXTENSIONS = ["txt", "md", "srt", "vtt"];

export const ALL_SUPPORTED_EXTENSIONS = [
  ...MEDIA_FILE_EXTENSIONS,
  ...TEXT_FILE_EXTENSIONS,
];

/**
 * Get audio-only extensions (exclude video formats)
 */
export const AUDIO_EXTENSIONS = MEDIA_FILE_EXTENSIONS.filter(
  (ext) => !VIDEO_EXTENSIONS.includes(ext)
);
